// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"b83ff276","89":"81a985fa","375":"715b6888","619":"aafe0176","811":"f7031598"}[chunkId] + ".chunk.css";
};